<script lang="ts">
	const actions = [
		{
			title: 'New Repository',
			description: 'Create a new Git repository',
			icon: '📦',
			color: 'bg-blue-500',
			hoverColor: 'hover:bg-blue-600',
			action: () => (window.location.hash = '/repositories/new')
		},
		{
			title: 'Deploy Project',
			description: 'Deploy from Git or upload code',
			icon: '🚀',
			color: 'bg-green-500',
			hoverColor: 'hover:bg-green-600',
			action: () => (window.location.hash = '/deployments/new')
		},
		{
			title: 'Create Database',
			description: 'PostgreSQL, MySQL, or MongoDB',
			icon: '🗄️',
			color: 'bg-purple-500',
			hoverColor: 'hover:bg-purple-600',
			action: () => (window.location.hash = '/databases/new')
		},
		{
			title: 'Import Project',
			description: 'From GitHub, GitLab, or Bitbucket',
			icon: '📥',
			color: 'bg-orange-500',
			hoverColor: 'hover:bg-orange-600',
			action: () => (window.location.hash = '/import')
		}
	];
</script>

<div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
	<h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Quick Actions</h2>
	<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
		{#each actions as action}
			<button
				onclick={action.action}
				class="group relative p-4 rounded-lg border-2 border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 transition-all duration-200 hover:shadow-md text-left"
			>
				<div class="flex items-start space-x-3">
					<div
						class="{action.color} {action.hoverColor} w-10 h-10 rounded-lg flex items-center justify-center text-2xl transition-colors"
					>
						{action.icon}
					</div>
					<div class="flex-1 min-w-0">
						<h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100 group-hover:text-gray-700 dark:group-hover:text-gray-200">
							{action.title}
						</h3>
						<p class="text-xs text-gray-500 dark:text-gray-400 mt-1">{action.description}</p>
					</div>
				</div>
			</button>
		{/each}
	</div>
</div>
